import MyAccountDetails from './MyAccountDetails'

export default MyAccountDetails
// eslint-disable-next-line import/export
export * from './MyAccountDetails'
